import React, { useState } from "react";
import { FALLBACK_IMAGE } from "../Parts";

/**
 * Product image with an automatic fallback.
 *
 * Catalogue images are served from the IndiaMART CDN. If one 404s or the CDN
 * blocks the request, we swap in a local placeholder rather than showing a
 * broken-image icon.
 */
export default function PartImage({ src, alt, className = "" }) {
  const [current, setCurrent] = useState(src);

  return (
    <img
      src={current}
      alt={alt}
      className={className}
      loading="lazy"
      onError={() => {
        if (current !== FALLBACK_IMAGE) setCurrent(FALLBACK_IMAGE);
      }}
    />
  );
}
